import React, { memo, useEffect, useState } from "react";
import EmptyButton from "../SelectButton/EmptyButton";
import FilledButton from "../SelectButton/FilledButton";
import { Observer, observer } from "mobx-react";
import PerformanceStore from "../../store/PerformanceStore";
import AuthStore from "../../store/AuthStore";

const FamilyCard = observer(
  ({
    familyDetails,
    familyId,
    onSelect,

    search,
    setStart,
    selectedFamily,
    selectedUser,
  }) => {
    const [selected, setSelected] = useState({
      id: "",
      selectedFamilyId: "",
      isSelected: false,
      familyDetails: null,
    });

    useEffect(() => {}, [selected]);

    const getDefaultImage = (name) => {
      return (
        <div className="profileImageDefault" aria-hidden={true}>
          {name[0]}
        </div>
      );
    };

    const getClasses = (condition, index, length, node1) => {
      return !condition ? "card_containt blueBordertColor" : "card_containt containt_order";
    };

    const setFamily = (memberId, familyId, isSelected) => {
      const local = {
        id: memberId,
        selectedFamilyId: familyId,
        isSelected: isSelected,
        familyDetails,
      };
      setSelected(local);
    };
    useEffect(() => {
      setStart(true);
      // eslint-disable-next-line
    }, []);

    const highlighter = (name) => {
      if (name?.toLowerCase()?.includes(search?.toLowerCase()) && search) {
        let regex = new RegExp(`(${search})`, "gi");
        const parts = name?.split(regex);
        return parts?.map((part, index) =>
          part?.match(regex) ? <span className="highlight">{part}</span> : part
        );
      }
      return name;
    };

    return (
      <Observer>
        {() => (
          <div
            id={familyId}
            key={familyId}
            className={
              selectedFamily === familyId
                ? "eachCard selected_card_border"
                : "eachCard blueBordertColor"
            }
          >
            <div>
              <div
                id="card"
                className="card_body content"
                role="radiogroup"
                aria-labelledby={"select-family"}
              >
                <div className="card_header">
                  <h2>{highlighter(familyDetails?.family_name)}</h2>
                </div>
                {familyDetails?.memberList?.map((data, index) => (
                  // <div
                  //   id={`user-${data.user_id}`}
                  //   className={getClasses()}
                  //   key={data.user_id}
                  //   onClick={() => {
                  //     onSelect(data);
                  //     setFamily(
                  //       data.user_id,
                  //       familyId,
                  //       true,
                  //       document.getElementById(`user-select-${data?.user_id}`)
                  //     );
                  //   }}
                  // >
                  //   <button
                  //     id={`user-select-${data?.user_id}`}
                  //     name={data?.user_id}
                  //     className="selecter"
                  //   >
                  //     {data?.user_id !== selectedUser ? (
                  //       <EmptyButton />
                  //     ) : (
                  //       <FilledButton />
                  //     )}
                  //   </button>
                  //   <div>
                  //     {!data?.profile_pic ? (
                  //       getDefaultImage(data?.full_name)
                  //     ) : PerformanceStore.loaderClosingCheck?.[
                  //         `${data?.user_id}1`
                  //       ] &&
                  //       PerformanceStore.loaderClosingCheck?.[
                  //         `${data?.user_id}1`
                  //       ] === "pending" ? (
                  //       <>
                  //         <div className="skeleton" />
                  //         <div />
                  //       </>
                  //     ) : data?.profile_pic &&
                  //       !AuthStore.selectFamiliesPageAllImages?.[
                  //         data?.user_id
                  //       ] ? (
                  //       getDefaultImage(data?.full_name)
                  //     ) : (
                  //       <img
                  //         className="profileImage"
                  //         src={
                  //           AuthStore.selectFamiliesPageAllImages
                  //             ? AuthStore.selectFamiliesPageAllImages?.[
                  //                 data?.user_id
                  //               ]
                  //             : null
                  //         }
                  //         alt=""
                  //       />
                  //     )}
                  //   </div>
                  //   <div>
                  //     <span className="userName">
                  //       {highlighter(data?.full_name)}
                  //     </span>
                  //     <div
                  //       className="unableToAddUser"
                  //       id={`user-${data?.user_id}-msg`}
                  //     >
                  //       Cannot proceed with this user
                  //     </div>
                  //   </div>

                  //   {data?.isprimary && (
                  //     <span className="primary">Primary</span>
                  //   )}
                  // </div>
                  <label
                    id={`user-${data.user_id}`}
                    className={getClasses()}
                    key={data.user_id}
                  >
                    <input
                      type="radio"
                      name="client"
                      value={data?.user_id}
                      checked={data?.user_id === selectedUser}
                      className="radioInput"
                      // onChange={handleChange}
                      onChange={(value) => {
                        onSelect(data);
                        setFamily(
                          data.user_id,
                          familyId,
                          true,
                          document.getElementById(
                            `user-select-${data?.user_id}`
                          )
                        );
                      }}
                    />

                    <div
                      id={`user-select-${data?.user_id}`}
                      name={data?.user_id}
                      className="selecter"
                    >
                      {data?.user_id !== selectedUser ? (
                        <EmptyButton />
                      ) : (
                        <FilledButton />
                      )}
                    </div>
                    <div>
                      {!data?.profile_pic ? (
                        getDefaultImage(data?.full_name)
                      ) : PerformanceStore.loaderClosingCheck?.[
                          `${data?.user_id}1`
                        ] &&
                        PerformanceStore.loaderClosingCheck?.[
                          `${data?.user_id}1`
                        ] === "pending" ? (
                        <>
                          <div className="skeleton" />
                          <div />
                        </>
                      ) : data?.profile_pic &&
                        !AuthStore.selectFamiliesPageAllImages?.[
                          data?.user_id
                        ] ? (
                        getDefaultImage(data?.full_name)
                      ) : (
                        <img
                          className="profileImage"
                          src={
                            AuthStore.selectFamiliesPageAllImages
                              ? AuthStore.selectFamiliesPageAllImages?.[
                                  data?.user_id
                                ]
                              : null
                          }
                          alt=""
                        />
                      )}
                    </div>
                    <div>
                      <h3 className="userName">
                        {highlighter(data?.full_name)}
                      </h3>
                      <div
                        className="unableToAddUser"
                        id={`user-${data?.user_id}-msg`}
                      >
                        Cannot proceed with this user
                      </div>
                    </div>

                    {data?.isprimary && (
                      <span className="primary blueBgtColor">Primary</span>
                    )}
                  </label>
                ))}
              </div>
            </div>
          </div>
        )}
      </Observer>
    );
  }
);

export default memo(FamilyCard);
